<template>
  <component v-if="layout" :is="layout">
      <v-snackbar
        slot="snackbar-content"
        v-model="snackbar.display"
        top
        right
        :color="snackbar.color"
      >
        {{ snackbar.message }}
      </v-snackbar>
    <router-view />
  </component>
</template>

<script>
import { 
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from '@/common/event.types';

export default {
  name: 'App',
  computed: {
    layout() {
      return this.$route.meta.layout;
    }
  },
  data: () => ({
    snackbar: {
      display: false,
      color: 'success',
      message: ''
    }
  }),
  mounted() {
    this.$eventHub.$on(NOTIFICATION_SUCCESS, ({ message }) => {
      this.snackbar.display = true;
      this.snackbar.color = 'success';
      this.snackbar.message = message;
    })

    this.$eventHub.$on(NOTIFICATION_ERROR, ({ message }) => {
      this.snackbar.display = true;
      this.snackbar.color = 'error';
      this.snackbar.message = message;
    })
  }
};
</script>

<style lang="scss">
  @import './styles/main';
</style>
